import { Store, Module, ActionContext } from "vuex";
import ListModule from "../list-module";
import ListState from "../list-state";
import Ajax from "../../../lib/ajax";
import PageResult from "@/store/entities/page-result";
import ListMutations from "../list-mutations";
import SupplierOffer from "../../entities/booking/supplierOffer";

interface SupplierOfferState extends ListState<SupplierOffer> {
  editSupplierOffer: SupplierOffer;
}
class SupplierOfferMutations extends ListMutations<SupplierOffer> {}
class SupplierOfferModule extends ListModule<
  SupplierOfferState,
  any,
  SupplierOffer
> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<SupplierOffer>(),
    loading: false,
    editSupplierOffer: new SupplierOffer(),
  };
  actions = {
    async getAll(
      context: ActionContext<SupplierOfferState, any>,
      payload: any,
    ) {
      context.state.loading = true;
      let reponse = await Ajax.get("/api/services/app/SupplierOffer/GetAll", {
        params: payload.data,
      });
      context.state.loading = false;
      context.state.list = reponse.data.result.items;
      context.state.totalCount = reponse.data.result.totalCount;
    },
    async updateSupplierIdById(
      context: ActionContext<SupplierOfferState, any>,
      payload: any,
    ) {
      return await Ajax.put(
        "/api/services/app/SupplierOffer/UpdateSupplierIdById",
        payload.data,
      );
    },
    async update(
      context: ActionContext<SupplierOfferState, any>,
      payload: any,
    ) {
      return await Ajax.put(
        "/api/services/app/SupplierOffer/Update",
        payload.data,
      );
    },
    async copyOffersToNextMonth() {
      return await Ajax.post(
        "/api/services/app/SupplierOffer/CopyOffersToNextMonth",
      );
    },
    async create(
      context: ActionContext<SupplierOfferState, any>,
      payload: any,
    ) {
      return await Ajax.post(
        "/api/services/app/SupplierOffer/Create",
        payload.data,
      );
    },

    async delete(
      context: ActionContext<SupplierOfferState, any>,
      payload: any,
    ) {
      await Ajax.delete(
        "/api/services/app/SupplierOffer/Delete?Id=" + payload.data.id,
      );
    },
    async get(context: ActionContext<SupplierOfferState, any>, payload: any) {
      let reponse = await Ajax.get(
        "/api/services/app/SupplierOffer/Get?Id=" + payload.id,
      );
      return reponse.data.result as SupplierOffer;
    },
  };
  mutations = {
    setCurrentPage(state: SupplierOfferState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: SupplierOfferState, pagesize: number) {
      state.pageSize = pagesize;
    },
    edit(state: SupplierOfferState, supplierSupplierOffer: SupplierOffer) {
      state.editSupplierOffer = supplierSupplierOffer;
    },
  };
}
const supplierSupplierOfferModule = new SupplierOfferModule();
export default supplierSupplierOfferModule;
